import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../actions/index';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CloseIcon from '@material-ui/icons/Close';

import { _ } from '../../functions/translator.js';
import { getUsername } from '../../functions/getter.js';
import { FilterActions } from '../../constants/constants.js';
import { postData } from '../../functions/postData.js';

class UserDropdown extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            userId: 0,
        }
    }

    handleUserChange = async (event) => {
        const userId = event.target.value;
        this.setState({ userId: userId });
        if (!userId) {
            this.props.filterChange(FilterActions.USERS_IN_CHARGE, []);
            this.props.filterChange(FilterActions.CARDS_GROUP_IDS, null);
            return;
        }
        const urlPost = {
            project_id: window.project_id,
            filter_user_id: userId,
        }
        const response = await postData('/web-api/get-cards-groups-in-charge', urlPost);
        const cardsGroupIds = response.cards_group_ids ? response.cards_group_ids : [];
        this.props.filterChange(FilterActions.USERS_IN_CHARGE, [userId]);
        this.props.filterChange(FilterActions.CARDS_GROUP_IDS, cardsGroupIds);
    }

    handleClose = (event) => {
        this.props.filterChange(FilterActions.USERS_IN_CHARGE, []);
        this.props.filterChange(FilterActions.CARDS_GROUP_IDS, null);
        this.props.closeCallback(event);
    }

    render() {
        const usersList = []
        usersList.push(
            <MenuItem key={0} value={0}>
                {_('Todo')}
            </MenuItem>
        )
        for (const userData of Object.values(this.props.projectUsers)) {
            const userName = getUsername(userData.id, this.props.projectUsers);
            usersList.push(
                <MenuItem key={userData.id} value={userData.id}>
                    {userName}
                </MenuItem>
            )
        }
        return(
            <div className={this.props.extraClass}>
                <p className='text'>
                    { _('Usuario') }
                    <CloseIcon className='float-right cursor-pointer' data-type='user' onClick={this.handleClose}/>
                </p>
                <Select 
                    value={this.state.userId} 
                    onChange={this.handleUserChange}>
                    {usersList}
                </Select>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        projectUsers : state.projectUsers,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange : filterChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(UserDropdown);
